const brands = [
  'nyx',
  'clinique',
  'benefit',
  'smashbox',
  'almay',
  'covergirl',
  'physicians formula',
  'maybelline',
  'rejuva minerals',
  'lotus cosmetics usa',
]

const productTag = [
  'All Tags',
  'Vegan',
  'cruelty free',
  'EcoCert',
  'Chemical Free',
  'Gluten Free',
  'CertClean',
  'purpicks',
  'No Talc',
  'Hypoallergenic',
  'EWG Verified',
  'USDA Organic',
  'Natural',
  'Organic',
  'water free',
  'Silicone free',
]

export function getBrands() {
  return brands
}

export function getProductTag() {
  return productTag
}
